import React from "react"
import PropTypes from "prop-types"
import { css } from "@emotion/core"
import i18n from "../../config/i18n"
import { colors } from "../styles/styles"
import Header from "./header"
import Footer from "./footer"
import "../styles/styles.scss"

const LocaleContext = React.createContext()

const Layout = ({
  data,
  children,
  location,
  pageContext: { uid, locale, allHeadersAndFooters = "" },
}) => {
  const { allHeaders, allFooters } = allHeadersAndFooters
  return (
    <>
      <LocaleContext.Provider value={{ locale, i18n, location }}>
        <Header allHeaders={allHeaders} />
        <main css={main}>{children}</main>
        <Footer allFooters={allFooters} />
      </LocaleContext.Provider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export { Layout, LocaleContext }

const main = css`
  .is-theme1 {
    background: ${colors.seashellPeach};
  }
  .is-theme2 {
    background: ${colors.zircon};
  }
  .is-themeGradientH {
    background-image: linear-gradient(
      to left,
      #f0f5ff,
      rgba(255, 255, 255, 0.5),
      #f0f5ff
    );
  }
  .is-themeGradientV {
    background-image: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(239, 243, 255, 0.62) 50%,
      rgba(255, 255, 255, 1) 50%
    );
  }
  .hasRichText {
    a {
      text-decoration: underline;
      color: ${colors.blue};
      &:hover {
        color: ${colors.orange};
      }
    }
    ul,
    ol {
      padding: 20px 0;
      li {
        list-style: square inside none;
      }
    }
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: ${colors.orange};
      font-size: 1.2rem;
    }
  }

  .has-text-weight-extralight {
    font-weight: 200;
  }

  .btn-shadow {
    box-shadow: 0 12px 14px ${colors.blueLightOne};
  }

  .is-align-items-center {
    align-items: center;
  }

  .is-margin-0-auto {
    margin: 0 auto;
  }

  .has-background-blue {
    background-color: ${colors.blue};
  }

  .button__gradient-border {
    border: solid 1px transparent;
    background-image: linear-gradient(
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0)
      ),
      ${colors.orangeGradient};
    background-origin: border-box;
    background-clip: content-box, border-box;
    box-shadow: 2px 1000px 1px #fff inset;
  }

  .button__gradient-border:hover,
  a.has-background-white.button__gradient-border.has-text-primary:hover,
  .button__gradient-border.is-active {
    box-shadow: none;
    color: #fff !important;
  }

  .form__outline {
    .has-icons-left {
      input {
        padding-left: 2.5em;
      }
    }

    .input,
    textarea,
    select {
      border-top: 0;
      border-right: 0;
      border-left: 0;
      border-radius: 0;
      border-bottom: 1px solid ${colors.borderForm};
      background: transparent;
      box-shadow: none;
      padding-left: 0;
    }

    .control.has-icons-left .icon {
      color: ${colors.blue};
    }

    select,
    .select {
      width: 100%;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    background: white;
    padding: 20px;
    height: 50px;
    width: 50px;
    border-radius: 50%;
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 15px;
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#fd7543),
      to(#de4e4e)
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .grecaptcha-badge {
    visibility: hidden;
  }
`
